import { PaperClipIcon } from "components/Icons";
import IconButton from "componentsv2/button/IconButton";

export function attachmentIcon(active, onClick) {
  if (!active) return null;
  return (
    <PaperClipIcon
      className="h-8 w-8 text-slate-600 stroke-2 p-1 cursor-pointer hover:stroke-blue-400"
      aria-hidden="true"
      onClick={onClick}
      content="board.button_attachment"
    />
  );
}

export function saveIcon(active, onClick) {
  if (!active) return null;
  return (
    <IconButton
      onClick={() => onClick("save")}
      name="save"
      content="board.button_save"
      color="gray"
    />
  );
}

export function deleteIcon(active, onClick) {
  if (!active) return null;
  return (
    <IconButton
      onClick={onClick}
      name="delete"
      color="rose"
      content="board.button_delete"
    />
  );
}
